import { ControlList, Dialog, useTranslations } from "@harea/component";
import { useRefuseDayOffForm } from "hooks/useRefuseDayOffForm";

export const RefuseDayOffDialog = ({ open, onClose, onConfirm }: Props) => {
    const [REFUSE_TITLE, REFUSE_CONFIRM, CANCEL] = useTranslations(i18n);
    const refuseDayOffForm = useRefuseDayOffForm();

    const handleSubmit = (value: any) => {
        const finalReason = value.refuseReason === "other" ? value.customReason : value.refuseReason;
        onConfirm(finalReason);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={REFUSE_TITLE}
        >
            <div className="flex flex-col gap-4">
                <p>{REFUSE_CONFIRM}</p>
                <ControlList
                    {...refuseDayOffForm}
                    onSubmited={handleSubmit}
                    onCancel={onClose}
                />
            </div>
        </Dialog>
    );
};

const i18n = [
    "std_refuse",
    "BSMRH.DayOff.Refuse.Confirm.Message",
    "std_cancel"
];

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: (reason: string) => void;
};
